import React, { useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import Dropdown from "../dropdown/Dropdown";
import axios from "axios";
import { apiUrl } from "../../../constants";
import "./ListSubheader.css";

const ListSubheader = ({ control }) => {
  const [result, setResult] = useState([]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    async function getAll() {
      const jwtToken = localStorage.getItem("token");
      try {
        const { data } = await axios.get(`${apiUrl}/api/formsettings/subheadings`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        setResult(data);
      } catch (e) {
        console.error(e);
        if (e.response !== undefined) {
          console.error(e.response.data.message);
        }
      }
    }
    getAll();
  }, []);

  useEffect(() => {
    const options = [];
    result.forEach((currentSubheading) => {
      const newOption = {
        label: currentSubheading.subheading,
        value: currentSubheading.subheading,
      };
      options.push(newOption);
    });
    setOptions(
      options.sort((a, b) =>
        a.value === b.value ? 0 : a.value < b.value ? -1 : 1
      )
    );
  }, [result]);

  return (
    <section className="select-wrapper subheader-wrapper">
      <Controller
        control={control}
        name={`listSubheader`}
        render={({ field: { onChange, value } }) => (
          <Dropdown
            label="Subheading template list"
            options={options}
            value={value}
            onChange={onChange}
          />
        )}
      />
    </section>
  );
};

export default ListSubheader;
